import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HomeHelper from '../../Components/HomeHelper';
import Footer from '../../Components/Footer';
import '../../Style/NoticeBoard.css';
import { useHistory, withRouter } from 'react-router-dom';
import { studentNoticeBoard } from '../../redux/action/studentAction'

const StudentNoticeBoard = () => {
  const store = useSelector(store => store);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(studentNoticeBoard())
 },[])
  return (
    <div>
      {store.student.isAuthenticated ? (
        <>
          <HomeHelper />
          <div className='mainHome'>
            <div className="container-fluid mainBg d-flex justify-content-center align-items-center" style={{ backgroundImage: 'url("/image/pattern.png")', backgroundRepeat: 'repeat' }}>
              <div className="row mainNB my-3 container">
                <div className="col-md-12 nBorad w-100 m-auto">
                  <h2 className='text-light text-center mt-3'>Notice Board</h2>
                  <div className=" row m-3">
                    <div className="col-2">
                      <h4>Important: </h4> 
                    </div>
                    <div className="col-md-8 impotentNews">
                    {store.student.isAuthenticated && store.student.notices.length > 0 ? (
                      <div>
                        <p>{store.student.notices[0].notice}</p>
                      <img src={store.student.notices[0].noticeImg} className='img-fluid' alt="" />
                      </div>
                    ) : (
                      <p>Loding...</p>
                    )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      ) : (
        history.push('/')
      )}
    </div>
  );
};

export default withRouter(StudentNoticeBoard);
